"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleMediaUpdateDTO = exports.S3MediaCreateURLDTO = exports.VehicleMediaCreateS3UrlDTO = exports.VehicleMediaFilterDTO = exports.VehicleMediaCreateDTO = void 0;
const class_validator_1 = require("class-validator");
const enums_1 = require("../enums");
const class_transformer_1 = require("class-transformer");
class VehicleMediaCreateDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleMediaCreateDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", String)
], VehicleMediaCreateDTO.prototype, "vehicleId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.VehicleMediaType),
    __metadata("design:type", String)
], VehicleMediaCreateDTO.prototype, "mediaType", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleMediaCreateDTO.prototype, "mediaUrl", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleMediaCreateDTO.prototype, "placeholder", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleMediaCreateDTO.prototype, "thumbnailUrl", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], VehicleMediaCreateDTO.prototype, "mediaIndex", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], VehicleMediaCreateDTO.prototype, "isPrimary", void 0);
exports.VehicleMediaCreateDTO = VehicleMediaCreateDTO;
class VehicleMediaFilterDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleMediaFilterDTO, plain);
    }
}
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], VehicleMediaFilterDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], VehicleMediaFilterDTO.prototype, "vehicleId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.VehicleMediaType, { each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], VehicleMediaFilterDTO.prototype, "mediaType", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], VehicleMediaFilterDTO.prototype, "mediaUrl", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], VehicleMediaFilterDTO.prototype, "thumbnailUrl", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], VehicleMediaFilterDTO.prototype, "isPrimary", void 0);
exports.VehicleMediaFilterDTO = VehicleMediaFilterDTO;
class VehicleMediaCreateS3UrlDTO {
    constructor() { }
}
exports.VehicleMediaCreateS3UrlDTO = VehicleMediaCreateS3UrlDTO;
class S3MediaCreateURLDTO {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], S3MediaCreateURLDTO.prototype, "vehicleId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], S3MediaCreateURLDTO.prototype, "folder", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], S3MediaCreateURLDTO.prototype, "files", void 0);
exports.S3MediaCreateURLDTO = S3MediaCreateURLDTO;
class VehicleMediaUpdateDTO {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleMediaUpdateDTO, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => VehicleMediaCreateDTO) // This transforms each object in the array to the OtherDetailsDTO class
    ,
    __metadata("design:type", Array)
], VehicleMediaUpdateDTO.prototype, "data", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], VehicleMediaUpdateDTO.prototype, "replace", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => VehicleMediaFilterDTO) // Create a VehicleMediaFilter class
    ,
    __metadata("design:type", VehicleMediaFilterDTO)
], VehicleMediaUpdateDTO.prototype, "filter", void 0);
exports.VehicleMediaUpdateDTO = VehicleMediaUpdateDTO;
